<template>
  <LazyHomeCommonLayout :is-blog-banner="true">
    <template #content>
      <LazyHomeSubPagesPlatformSkillCertify />
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {LazyHomeSubPagesPlatformSkillCertify} from "#components";
import {useSiteNavigationLd} from "~/composables/useSiteNavigationLd";
import {useSeoMeta} from "~/composables/useSeoMeta";

const { t } = useI18n();
const siteLinkScript = useSiteNavigationLd();
const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: t("seo.home.skillCertify.title"),
  meta: [
    {
      name: 'description',
      content: t("seo.home.skillCertify.meta.description")
    },
    {
      name: 'title',
      content: t("seo.home.skillCertify.meta.title")
    },
    {
      name: 'robots',
      content: 'index,follow'
    }
  ],
  script: [siteLinkScript],
  link: [
    ...getHreflangLinks.value,
    { rel: 'canonical', href: getCanonical.value }
  ]
})

definePageMeta({
  // 언어별 경로를 alias로 추가
  alias: [
    '/en/home/skillCertify',
    '/ja/home/skillCertify',
    '/ko/home/skillCertify',
    '/vi/home/skillCertify',
  ]
})
</script>